import KTWizard from '../../../../theme/_assets/js/wizard';
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import { connect } from "react-redux";
import dateFormat from 'dateformat';
import firebase from "firebase/app";
import "firebase/storage";
var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY
var wizard = null;

class CreateApartmentuserInfoagg extends Component {

  constructor(props) {
    super(props);
    this.state = {  
      "apartmentName": "", "associationName": "", "customerUserId": "", "doorNumber": "",
      "streetName": "", "area": "", "city": "Chennai", "landmark": "", "pincode": "", apartmentType: "", roadSize: "",
      "apartmentPhoneNumber": "", distanceBetweenGateAndSump: "", "numberOfTowers": "", "numberOfHomes": "", "tankCapacity": "", "dailyNeed": "", "totalDissolvedSolids": "600-900(Fair)",
      "pocName1": "", "pocContactNumber1": "", "pocName2": "", "pocContactNumber2": "",
      showModal: false, cities: [], apartmentTypes: [], throwUserError: false,apartmentcontact1Required:false,apartmentcontact2Required: false,
      percentage: 0, "apartmentNameRequired": false, "associationNameRequired": false, "doorNumberRequired": false, //"streetNameRequired": false,
      "areaRequired": false, "cityRequired": false, "landmarkRequired": false, "pincodeRequired": false, "apartmentPhoneNumberRequired": false,
      // "numberOfTowersRequired": false, "numberOfHomesRequired": false,
      "distanceBetweenGateAndSumpRequired": false,
      "tankCapacityRequired": false, "pocName1Required": false,
      "pocContactNumber1Required": false, "pocName2Required": false, "pocContactNumber2Required": false, "dailyNeedRequired": false,
      "modal": false, userFirstName: "", userLastName: "", userPhoneNumber: "", passLength: false,
      userEmail: "", userPassword: "", userConPassword: "", "pocUserId": "", pocCustomerName: "", pocCustomerId: "", userId: "", profileImg: '',contactdocumenturl: '',
      customerBankId: "", customerBLId: "", customerAddId: "", errors: {
        firstName: '',
        emailId: '',
        password: '',
      },
      lat: 0, lng: 0, disableSubmit: false
    };
    this.submit = this.submit.bind(this);
    this.handleFormFields = this.handleFormFields.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.modalToggle = this.modalToggle.bind(this);
    this.userToggle = this.userToggle.bind(this);
	this.handleChange = this.handleChange.bind(this);
	this.documenturlChange= this.documenturlChange.bind(this);
    this.KTWizard = React.createRef();
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    this.basicDetailValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    this.apartmentDetailValidator = new SimpleReactValidator({ messages: { currency: "Must be a valid number" }, autoForceUpdate: this, className: 'text-danger' });
    this.pocValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    this.userValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    this.leaveHandle = this.leaveHandle.bind(this);
    this.passwordRef = React.createRef();
  }

	handleChange = event => {
		this.setState({profileImg: event.target.files[0]}, function () { });
 
	} 
	documenturlChange = event => {
		this.setState({contactdocumenturl: event.target.files[0]}, function () { });
	}
  modalToggle = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  toggle = () => {
    let path = "/basic-details";
    this.props.history.push({ pathname: path });
  }

  userToggle() {
    this.setState({
      throwUserError: false,
      modal: !this.state.modal, userFirstName: "", userLastName: "", userPhoneNumber: "",
      userEmail: "", userPassword: "", userConPassword: ""
    });
  }



  handleFormFields = (event) => {
    this.apartmentDetailValidator.showMessageFor(event.target.name)
    this.basicDetailValidator.showMessageFor(event.target.name)
    this.pocValidator.showMessageFor(event.target.name)
    //this.validator.showMessageFor(event.target.name)
    switch (event.target.id) {
      case "uapartmentName":
        this.setState({ "apartmentName": event.target.value });
        break;
      case "uassociationName":
        this.setState({ "associationName": event.target.value });
        break;

      case "udoorNumber":
        this.setState({ "doorNumber": event.target.value });
        break;
      case "ustreetName":
        this.setState({ "streetName": event.target.value });
        break;
      case "uarea":
        this.setState({ "area": event.target.value });
        break;
      case "ucity":
        this.setState({ "city": event.target.value });
        break;
      case "ulandmark":
        this.setState({ "landmark": event.target.value });
        break;
      case "upincode":
        this.setState({ "pincode": event.target.value });
        break;
      case "uapartmentType":
        this.setState({ apartmentType: event.target.value });
        break;
	  case "uapartmentPhoneNumber":
        this.setState({ "apartmentPhoneNumber": event.target.value });
		this.apartmentcontactnumbervalid(event.target.value)
        break;
		
      case "uroadSize":
        this.setState({ roadSize: event.target.value });
        break;

      
      case "udistanceBetweenGateAndSump":
        this.setState({ "distanceBetweenGateAndSump": event.target.value });
        break;
      case "unumberOfTowers":
        this.setState({ "numberOfTowers": event.target.value });
        break;
      case "unumberOfHomes":
        this.setState({ "numberOfHomes": event.target.value });
        break;
      case "utankCapacity":
        this.setState({ "tankCapacity": event.target.value });
        break;
      case "udailyNeed":
        this.setState({ "dailyNeed": event.target.value });
        break;
      case "utotalDissolvedSolids":
        this.setState({ "totalDissolvedSolids": event.target.value });
        break;
      case "upocName1":
        this.setState({ "pocName1": event.target.value });
        break;
      case "upocContactNumber1":
        this.setState({ "pocContactNumber1": event.target.value });
		this.contactnumber1(event.target.value)
        break;
      case "upocName2":
        this.setState({ "pocName2": event.target.value });
        break;
      case "upocContactNumber2":
        this.setState({ "pocContactNumber2": event.target.value });
		this.contactnumber2(event.target.value)
        break;
      default:
        break;
    }

  }
  contactnumber1 = (data) => {
	   const postCustData = {  "contactnumber" : data }
		if(data != "" && this.state.userPhoneNumber != data) {
			  if(data.length === 10) {
				  fetch(process.env.REACT_APP_NODE_ENV + '/api/apartmentcustomer/contactnumber1', {
					  method: 'POST',
					  headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					  },
					  body: JSON.stringify(postCustData)
					}).then((res) => res.json())
					  .then((data) => {
						 
						console.log(data.error_token)
						if(data.error_token === 1) {
							this.setState({ apartmentcontact1Required: '1'})
						}
						else {
								this.setState({ apartmentcontact1Required: data.error_token })
						}
					   
					  })
					  .catch((err) => console.log(err))
						  
				}
				else if(data.length <= 9) {
					this.setState({ apartmentcontact1Required: 0 })
				}
				else if(data.length >= 11) {
					this.setState({ apartmentcontact1Required: 0 })
				}
		}
	}
	
 contactnumber2 = (data) => {
	   const postCustData = {  "contactnumber" : data }
		if(data != "" ) {
			if(this.props.userPhoneNumber === data) {
				this.setState({ apartmentcontact2Required: '1'})
			}
			  else {
			  if(data.length === 10) {
				  fetch(process.env.REACT_APP_NODE_ENV + '/api/apartmentcustomer/contactnumber2', {
					  method: 'POST',
					  headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					  },
					  body: JSON.stringify(postCustData)
					}).then((res) => res.json())
					  .then((data) => {
						 
						console.log(data.error_token)
						if(data.error_token === 1) {
							this.setState({ apartmentcontact2Required: '1'})
						}
						else {
								this.setState({ apartmentcontact2Required: data.error_token })
						}
					   
					  })
					  .catch((err) => console.log(err))
						  
				}
				else if(data.length <= 9) {
					this.setState({ apartmentcontact2Required: 0 })
				}
				else if(data.length >= 11) {
					this.setState({ apartmentcontact2Required: 0 })
				}
			  }
		}
	}
  apartmentcontactnumbervalid= (data) => {
	  const postCustData = {  "contactnumber" : data }
	  if(data != "") {
		  if(data.length === 10) {
			fetch(process.env.REACT_APP_NODE_ENV + '/api/apartmentcustomer/apartmentcontactnumber', {
				  method: 'POST',
				  headers: {
					'Content-Type': 'application/json',
					'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				  },
				  body: JSON.stringify(postCustData)
				}).then((res) => res.json())
				  .then((data) => {
					 
					//console.log(data.error_token)
					if(data.error_token === 1) {
						this.setState({ apartmentPhoneNumberRequired: '1'})
					}
					else {
							this.setState({ apartmentPhoneNumberRequired: data.error_token })
					}
				   
				  })
				  .catch((err) => console.log(err))
			}
			else if(data.length <= 9) {
				this.setState({ apartmentPhoneNumberRequired: 0 })
			}
			else if(data.length >= 11) {
				this.setState({ apartmentPhoneNumberRequired: 0 })
			}
		}
		else {
			this.setState({ apartmentPhoneNumberRequired: 0 })
		}
				 
	  
	  
  }

  leaveHandle = (event) => {
    event.preventDefault();
    this.validator.showMessageFor(event.target.name)
    const { id, value } = event.target;
    let errors = this.state.errors;

    switch (id) {
      case 'upassword':
        errors.password =
          value.length < 8
            ? 'Password must be 8 characters long!'
            : '';
        if (value.length < 8) {
          this.setState({ passLength: true });
        }
        else {
          this.setState({ passLength: false });
        }
        break;
      default:
        break;
    }

    this.setState({ errors, [id]: value }, () => {
    })
  }

  componentDidMount() {
	
		var dec = window.atob(localStorage.getItem("cust_apt_id"));
		this.setState({ pocUserId: dec })
    wizard = new KTWizard(this.KTWizard.current, {
      startStep: 1,
      clickableSteps: true
    });


    fetch(process.env.REACT_APP_NODE_ENV + "/api/master/fetchAllApartmentType", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    })
      .then(res => res.json())
      .then(data => { this.setState({ apartmentTypes: data }) })
      .catch(error => this.setState({ apartmentTypes: [] }))

    fetch(process.env.REACT_APP_NODE_ENV + "/api/master/fetchAllCity", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    })
      .then(res => res.json())
      .then(data => { this.setState({ cities: data }) })
      .catch(error => this.setState({ cities: [] }))
	  
	  
	  const url = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/cgetUserbyuserId/" + dec
	fetch(url,{
		method:'GET',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
		  }
	}).then(
		response => { return response.json(); }
	).then(data => {
		// console.log(data)
		// alert(data)
		this.setState({
			pocName1:data.userFirstName,
			pocContactNumber1:data.userPhoneNumber
		})
	}).catch(error => console.log(error))

  };

  nextStep() {
	  toast.dismiss();
    if (wizard.getStep() == 2) {
      if (this.basicDetailValidator.allValid()) {
        if (this.state.percentage === 100) return;
        this.setState(prevState => ({ percentage: prevState.percentage + 20 }));

      } else {
        wizard.goPrev();
        toast.error("Please complete the required basic detail fields !!!", {
          position: toast.POSITION.TOP_CENTER,

        });
        this.basicDetailValidator.showMessages();
      }
    }
    if ((wizard.getStep() == 3)) {
      if ((this.apartmentDetailValidator.allValid()) &&  (this.state.apartmentPhoneNumberRequired != 1 || this.state.apartmentPhoneNumberRequired === "" )) {
        if (this.state.percentage === 100) return;
        this.setState(prevState => ({ percentage: prevState.percentage + 20 }));
      } else {
        wizard.goPrev();
        toast.error("Please complete the required apartment detail fields !!!", {
          position: toast.POSITION.TOP_CENTER,

        });
        this.apartmentDetailValidator.showMessages();
      }
    }
    if (wizard.getStep() == 4) {
      if (this.pocValidator.allValid() && this.state.apartmentcontact2Required  != 1  && this.state.apartmentcontact1Required  != 1 ) {
        if (this.state.percentage === 100) return;
        this.setState(prevState => ({ percentage: prevState.percentage + 20 }));
      } else {
        wizard.goPrev();
        toast.error("Please complete the required poc fields !!!", {
          position: toast.POSITION.TOP_CENTER,

        });
        this.pocValidator.showMessages();
      }
    }

  }

  prevStep() {
    if (this.state.percentage === 100) return;
    this.setState(prevState => ({ percentage: prevState.percentage - 20 }));
  }

  submit = () => {

    if (wizard.getStep() == 4) {
      if (this.basicDetailValidator.allValid() && this.apartmentDetailValidator.allValid() && this.pocValidator.allValid() && this.state.apartmentcontact2Required  != 1  && this.state.apartmentcontact1Required  != 1  &&  (this.state.apartmentPhoneNumberRequired != 1 || this.state.apartmentPhoneNumberRequired === "" ) ) {
        
		var assing_profile=""
		if(this.state.profileImg != "" && this.state.contactdocumenturl != "") 
		{
			assing_profile="3"
		}
		else if(this.state.profileImg != "") {
			assing_profile="1"
		}
		else if(this.state.contactdocumenturl != "") {
			assing_profile="2"
		}
		this.setState({ disableSubmit: true });
		
		if(assing_profile === "3")
		{
			var Image_name =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.profileImg.name;
			const uploadTask = firebase.storage().ref(`media/${Image_name}`).put(this.state.profileImg).then(snapshot => {
				var Image_name1 =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.contactdocumenturl.name;
				const uploadTask = firebase.storage().ref(`media/${Image_name1}`).put(this.state.contactdocumenturl).then(snapshots => {
					
					const postCustData = {
						  "apartmentName": this.state.apartmentName, "associationName": this.state.associationName,
						  "customerUserId": this.state.customerUserId, "doorNumber": this.state.doorNumber,
						  "streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
						  "state": this.state.state, "landmark": this.state.landmark,
						  "pincode": this.state.pincode, apartmentType: this.state.apartmentType, roadSize: this.state.roadSize,
						  "apartmentPhoneNumber": this.state.apartmentPhoneNumber,
						  "distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
						  "numberOfTowers": this.state.numberOfTowers, "numberOfHomes": this.state.numberOfHomes,
						  "tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed,
						  "totalDissolvedSolids": this.state.totalDissolvedSolids,
						  "pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
						  "pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2,
						  "pocUserId": this.state.pocUserId, "profileimageurl" :  snapshot.metadata.downloadURLs[0]  ,"contractdocumenturl": snapshots.metadata.downloadURLs[0],
						  userId: "", customerBankId: "", customerBLId: "", customerAddId: ""
						};
					
						
						fetch(process.env.REACT_APP_NODE_ENV + '/api/apart-customer/createCustomer', {
						  method: 'POST',
						  headers: {
							'Content-Type': 'application/json',
							'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
						  },
						  body: JSON.stringify(postCustData)
						}).then((res) => res.json())
						  .then((data) => {

							if (data !== "") {
							  fetch(
								"https://maps.googleapis.com/maps/api/geocode/json?address=" +
								this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
								"&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
							  )
								.then(data => data.json())
								.then(resp => {
								  const { lat, lng } = resp.results[0].geometry.location;
								  this.createAddress(data.apartmentId, lat, lng)
								  this.setState({ lat: lat, lng: lng })
								})
								.catch(err => console.log(err));
							}
							toast.success("Profile Details Updated successfully!!!", {
							  position: toast.POSITION.TOP_CENTER,

							});
						  })
						  .catch((err) => console.log(err))
					
				})
			})
		}
		else if(assing_profile === "1") {
			var Image_name =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.profileImg.name;
			const uploadTask = firebase.storage().ref(`media/${Image_name}`).put(this.state.profileImg).then(snapshot => {
				const postCustData = {
				  "apartmentName": this.state.apartmentName, "associationName": this.state.associationName,
				  "customerUserId": this.state.customerUserId, "doorNumber": this.state.doorNumber,
				  "streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
				  "state": this.state.state, "landmark": this.state.landmark,
				  "pincode": this.state.pincode, apartmentType: this.state.apartmentType, roadSize: this.state.roadSize,
				  "apartmentPhoneNumber": this.state.apartmentPhoneNumber,
				  "distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
				  "numberOfTowers": this.state.numberOfTowers, "numberOfHomes": this.state.numberOfHomes,
				  "tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed,
				  "totalDissolvedSolids": this.state.totalDissolvedSolids,
				  "pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
				  "pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2,
				  "pocUserId": this.state.pocUserId, "profileimageurl" :  snapshot.metadata.downloadURLs[0],
				  userId: "", customerBankId: "", customerBLId: "", customerAddId: ""
				};
			
				
				fetch(process.env.REACT_APP_NODE_ENV + '/api/apart-customer/createCustomer', {
				  method: 'POST',
				  headers: {
					'Content-Type': 'application/json',
					'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				  },
				  body: JSON.stringify(postCustData)
				}).then((res) => res.json())
				  .then((data) => {

					if (data !== "") {
					  fetch(
						"https://maps.googleapis.com/maps/api/geocode/json?address=" +
						this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
						"&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
					  )
						.then(data => data.json())
						.then(resp => {
						  const { lat, lng } = resp.results[0].geometry.location;
						  this.createAddress(data.apartmentId, lat, lng)
						  this.setState({ lat: lat, lng: lng })
						})
						.catch(err => console.log(err));
					}
					toast.success("Profile Details Updated successfully!!!", {
					  position: toast.POSITION.TOP_CENTER,

					});
				  })
				  .catch((err) => console.log(err))
				
			})
		}
		else if(assing_profile === "2") {
			var Image_name1 =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.contactdocumenturl.name;
				const uploadTask = firebase.storage().ref(`media/${Image_name1}`).put(this.state.contactdocumenturl).then(snapshots => {
					
						const postCustData = {
						  "apartmentName": this.state.apartmentName, "associationName": this.state.associationName,
						  "customerUserId": this.state.customerUserId, "doorNumber": this.state.doorNumber,
						  "streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
						  "state": this.state.state, "landmark": this.state.landmark,
						  "pincode": this.state.pincode, apartmentType: this.state.apartmentType, roadSize: this.state.roadSize,
						  "apartmentPhoneNumber": this.state.apartmentPhoneNumber,
						  "distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
						  "numberOfTowers": this.state.numberOfTowers, "numberOfHomes": this.state.numberOfHomes,
						  "tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed,
						  "totalDissolvedSolids": this.state.totalDissolvedSolids,
						  "pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
						  "pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2,
						  "pocUserId": this.state.pocUserId,"contractdocumenturl": snapshots.metadata.downloadURLs[0],
						  userId: "", customerBankId: "", customerBLId: "", customerAddId: ""
						};
					
						
						fetch(process.env.REACT_APP_NODE_ENV + '/api/apart-customer/createCustomer', {
						  method: 'POST',
						  headers: {
							'Content-Type': 'application/json',
							'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
						  },
						  body: JSON.stringify(postCustData)
						}).then((res) => res.json())
						  .then((data) => {

							if (data !== "") {
							  fetch(
								"https://maps.googleapis.com/maps/api/geocode/json?address=" +
								this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
								"&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
							  )
								.then(data => data.json())
								.then(resp => {
								  const { lat, lng } = resp.results[0].geometry.location;
								  this.createAddress(data.apartmentId, lat, lng)
								  this.setState({ lat: lat, lng: lng })
								})
								.catch(err => console.log(err));
							}
							toast.success("Profile Details Updated successfully!!!", {
							  position: toast.POSITION.TOP_CENTER,

							});
						  })
						  .catch((err) => console.log(err))
					
				})
		}
		else {
			
			const postCustData = {
          "apartmentName": this.state.apartmentName, "associationName": this.state.associationName,
          "customerUserId": this.state.customerUserId, "doorNumber": this.state.doorNumber,
          "streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
          "state": this.state.state, "landmark": this.state.landmark,
          "pincode": this.state.pincode, apartmentType: this.state.apartmentType, roadSize: this.state.roadSize,
          "apartmentPhoneNumber": this.state.apartmentPhoneNumber,
          "distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
          "numberOfTowers": this.state.numberOfTowers, "numberOfHomes": this.state.numberOfHomes,
          "tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed,
          "totalDissolvedSolids": this.state.totalDissolvedSolids,
          "pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
          "pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2,
          "pocUserId": this.state.pocUserId,
          userId: "", customerBankId: "", customerBLId: "", customerAddId: ""
        };
	
		
        fetch(process.env.REACT_APP_NODE_ENV + '/api/apart-customer/createCustomer', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify(postCustData)
        }).then((res) => res.json())
          .then((data) => {

            if (data !== "") {
              fetch(
                "https://maps.googleapis.com/maps/api/geocode/json?address=" +
                this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
                "&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
              )
                .then(data => data.json())
                .then(resp => {
                  const { lat, lng } = resp.results[0].geometry.location;
                  this.createAddress(data.apartmentId, lat, lng)
                  this.setState({ lat: lat, lng: lng })
                })
                .catch(err => console.log(err));
            }
            toast.success("Profile Details Updated successfully!!!", {
              position: toast.POSITION.TOP_CENTER,

            });
          })
          .catch((err) => console.log(err))
			
		}
		
		
		
        
		  
      } else {



        if (!this.pocValidator.allValid()) {
          toast.error("Please complete the required poc detail fields !!!", {
            position: toast.POSITION.TOP_CENTER,
          });
          this.basicDetailValidator.showMessages();
          wizard.goTo(3);
        }
        if (!this.apartmentDetailValidator.allValid()) {
          toast.error("Please complete the required apartment detail fields !!!", {
            position: toast.POSITION.TOP_CENTER,
          });
          this.basicDetailValidator.showMessages();
          wizard.goTo(2);
        }
        if (!this.basicDetailValidator.allValid()) {
          toast.error("Please complete the required basic detail fields !!!", {
            position: toast.POSITION.TOP_CENTER,
          });
          this.basicDetailValidator.showMessages();
          wizard.goTo(1);
        }
        this.forceUpdate();
      }
    }


  }

  createAddress = (apartmentId, lattitude, longitude) => {
    let postAddressData = {
      associateId: apartmentId, defaultAddress: "Yes",
      fullAddress: this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city, geolocationLat: lattitude, geolocationLng: longitude, label: "Default Shipping Address"
    };
    fetch(process.env.REACT_APP_NODE_ENV + '/api/address/createAddress', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postAddressData)
    }).then((response) => response.json())
      .then(data => {
        this.props.history.push({ pathname: "/aprt-customer/customer-list" });
      })
  }


  nextPath(path) {
    this.props.history.push(path);
  }



  validUserForm() {
    const { userFirstName, userLastName, userPhoneNumber, userEmail, userPassword, userConPassword } = this.state;
    let validUserFormFlag = false;
    if (userFirstName === '') {
      this.setState({ userFirstNameRequired: true });
      return validUserFormFlag;
    }
    else if (userLastName === '') {
      this.setState({ userLastNameRequired: true });
      return validUserFormFlag;
    }
    else if (userPhoneNumber === '') {
      this.setState({ userPhoneNumberRequired: true });
      return validUserFormFlag;
    }
    else if (userEmail === '') {
      this.setState({ userEmailRequired: true });
      return validUserFormFlag;
    }
    // else if (userPassword === '') {
    //   this.setState({ userPasswordRequired: true });
    //   return validUserFormFlag;
    // }
    // else if (userConPassword === '') {
    //   this.setState({ userConPasswordRequired: true });
    //   return validUserFormFlag;
    // }
    else {
      return true;
    }
  }



  userSubmit = () => {
    if (this.userValidator.allValid()) {
      let postUserData = {
        userFirstName: this.state.userFirstName, userLastName: this.state.userLastName, userPhoneNumber: this.state.userPhoneNumber,
        userEmail: this.state.userEmail, userPassword: this.state.userPassword, userType: "Apartment Customer"
      };
      postUserData = CryptoJS.AES.encrypt(JSON.stringify(postUserData),key).toString()
      fetch(process.env.REACT_APP_NODE_ENV + '/api/users/createUser', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify({ data: postUserData })
      }).then((response) => {
        if (response.status === 400) {
          this.setState({ throwUserError: true })
        }
        else { return response.json() }
      })
        .then((data) => {
          data = CryptoJS.AES.decrypt(data.userData,key)
          data = JSON.parse(data.toString(CryptoJS.enc.Utf8))
          this.setState({ modal: !this.state.modal, pocCustomerId: data.id, pocCustomerName: data.userEmail })
        })
        .catch((error) => console.log(error))
    } else {
      this.userValidator.showMessages();
      this.forceUpdate();
    }

  }

  render() {

    let userError = ""
    if (this.state.throwUserError) {
      userError = (<span style={{ color: "red" }}>Either Email/Phone Number Already Exist</span>)
    }
    let userForm = (<form>
      <div className="kt-form__section kt-form__section--first">
        <div className="kt-wizard-v1__form">
          <div className="row">
            <div className="col-xs-2">
              <div className="form-group">
                <label>First Name *</label>
                <input type="text" className="form-control" ref={this.firstNameRef} required name="first name" id="ufirstName" placeholder="First Name" value={this.state.userFirstName} onChange={this.handleUserFormFields} onBlur={this.leaveHandle} />
                {
                  this.userValidator.message('first name', this.state.userFirstName, 'required|alpha_space')
                }
                {
                  this.state.userFirstNameRequired &&
                  <span className="form-text text-muted">Please enter your First Name.</span>
                }

              </div></div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div className="col-xs-2">
              <div className="form-group">
                <label>Last Name *</label>
                <input type=" text" className="form-control" pattern="[A-Za-z]{3}" required name="last name" id="ulastName" placeholder="Last Name" value={this.state.userLastName} onChange={this.handleUserFormFields} />
                {
                  this.userValidator.message('last name', this.state.userLastName, 'required|alpha_space')
                }
                {
                  this.state.userLastNameRequired &&
                  <span className="form-text text-muted">Please enter your Last Name.</span>
                }

              </div></div></div>
          <div className="row">
            <div className="col-xs-2">
              <div className="form-group">
                <label>Phone Number *</label>
                <input type="text" className="form-control" required name="phone" id="uphoneNumber" placeholder="Phone Number" value={this.state.userPhoneNumber} onChange={this.handleUserFormFields} />
                {
                  this.userValidator.message('Phone Number', this.state.userPhoneNumber, 'required|phone|max:10')
                }
                {
                  this.state.userPhoneNumberRequired &&
                  <span className="form-text text-muted">Please enter your Phone Number.</span>
                }

              </div></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div className="col-xs-2">
              <div className="form-group">
                <label>E-mail *</label>
                <input type="text" className="form-control" required name="emailid" id="uemailId" placeholder="E-mail" value={this.state.userEmail} onChange={this.handleUserFormFields} />
                {
                  this.userValidator.message('E-mail', this.state.userEmail, 'required|email')
                }
                {
                  this.state.userEmailRequired &&
                  <span className="form-text text-muted">Please enter your E-mail .</span>
                }

              </div>
            </div></div>
          <div className="row">
            <div className="col-xs-2">
              <div className="form-group">
                <label>Password *</label>
                <input type="password" className="form-control" ref={this.passwordRef} required name="Password" id="upassword" placeholder="Enter Your Password" value={this.state.userPassword} onChange={this.handleUserFormFields} />
                {
                  this.userValidator.message('Password', this.state.userPassword, 'required|max:20|min:8')
                }
                {/* {
                  this.state.passLength &&
                  <span className="form-text text-muted"><div style={{ color: 'Red' }}>Password Must Be Minimum 8 characters</div></span>
                } */}
                {/* {
                  this.state.userPasswordRequired &&
                  <span className="form-text text-muted">Please enter your password.</span>
                } */}
              </div>
            </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div className="col-xs-2">
              <div className="form-group">
                <label>Confirm Password *</label>
                <input type="password" className="form-control" required name="Confirm Password" id="uconPassword" placeholder="Confirm Password" value={this.state.userConPassword} onChange={this.handleUserFormFields} />
                {this.userValidator.message('Confirm Password', this.state.userConPassword, `required|in:${this.state.userPassword}`, { messages: { in: 'Passwords need to match!' } })}
                {/* {
                  this.state.userConPasswordRequired &&
                  <span className="form-text text-muted">Please enter your password.</span>
                } */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    )

    let apartmentTypeData = this.state.apartmentTypes.map(data => (
      <option value={data.apartmentType}>{data.apartmentType}</option>
    ))

    let cityData = this.state.cities.map(data => (
      <option value={data.cityName}>{data.cityName}</option>
    ))

    return (<>
      <Breadcrumb>
        

         

        <Breadcrumb.Item active>Create Apartment Customer</Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <Modal isOpen={this.state.modal} style={{ width: "1000px", display: "block" }}>
          <Card >
            <Card.Body>
              <ModalHeader>
                Add User
                </ModalHeader>
              <ModalBody>
                {userForm}
                {userError}
              </ModalBody>
              <ModalFooter><div className="col-8 float-center">
                <Button variant="outline-primary" onClick={this.userSubmit}> Save </Button>
                &nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={this.userToggle}> Cancel </Button>
              </div>
              </ModalFooter>
            </Card.Body>
          </Card>
        </Modal>
      </div>
      <div>
        {/* <ProgressBar
            animated
            now={this.state.percentage}
            label={`${this.state.percentage}%`}
          /> */}
      </div>

      <div ref={this.KTWizard} className="kt-grid kt-wizard-v1 kt-wizard-v1--white" id="kt_wizard_v1" data-ktwizard-state="step-first">
        <div className="kt-grid__item">


          <div className="kt-wizard-v1__nav">

            <div className="kt-wizard-v1__nav-items kt-wizard-v1__nav-items--clickable">
              <div className="kt-wizard-v1__nav-item" data-ktwizard-type="step" data-ktwizard-state="current">
                <div className="kt-wizard-v1__nav-body">
                  <div className="kt-wizard-v1__nav-icon">
                    <i className="flaticon2-list-1"></i>
                  </div>
                  <div className="kt-wizard-v1__nav-label">
                    1. Billing Address
                </div>
                </div>
              </div>

              <div className="kt-wizard-v1__nav-item" data-ktwizard-type="step">
                <div className="kt-wizard-v1__nav-body">
                  <div className="kt-wizard-v1__nav-icon">
                    <i className="flaticon2-avatar"></i>
                  </div>
                  <div className="kt-wizard-v1__nav-label">
                    2.Apartment Details
                </div>
                </div>
              </div>


              <div className="kt-wizard-v1__nav-item" data-ktwizard-type="step">
                <div className="kt-wizard-v1__nav-body">
                  <div className="kt-wizard-v1__nav-icon">
                    <i className="flaticon2-avatar"></i>
                  </div>
                  <div className="kt-wizard-v1__nav-label">
                    3. Contact Details
                </div>
                </div>
              </div>



              <div className="kt-wizard-v1__nav-item" data-ktwizard-type="step">
                <div className="kt-wizard-v1__nav-body">
                  <div className="kt-wizard-v1__nav-icon">
                    <i className="flaticon-user-ok"></i>
                  </div>
                  <div className="kt-wizard-v1__nav-label">
                    4. Review and Submit
                </div>
                </div>
              </div>
            </div>
          </div>


        </div>
        {/* <!--begin: Form Wizard Form--> */}
        <div className="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
          {/* <!--begin: Form Wizard Form--> */}
          <form className="kt-form" id="kt_form" >

            {/* <!--begin: Form Wizard Step 1--> */}
            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content" data-ktwizard-state="current">
             
              <div className="kt-form__section kt-form__section--first">
                <div className="kt-wizard-v1__form">


                  

				<div className="kt-heading kt-heading--md">Billing Address </div>

                   <div className="form-group row">
                    <div className="col-lg-4">
                      <label>Apartment Name *</label>

                      <input type="text" className="form-control" name="apartmentName" id="uapartmentName" placeholder="Apartment Name" value={this.state.apartmentName} onChange={this.handleFormFields} />
                      {
                        this.basicDetailValidator.message('apartmentName', this.state.apartmentName, 'required|max:150')
                      }
                      {/* {
                        this.state.apartmentNameRequired &&
                        <span className="form-text text-muted">Please enter your Apartment Name.</span>
                      } */}
                    </div>


                    <div className="col-lg-4">

                      <label>Association Name </label>

                      <input type="text" className="form-control" name="Association Name" id="uassociationName" placeholder="Association Name" value={this.state.associationName} onChange={this.handleFormFields} />
                      {
                        this.basicDetailValidator.message('Association Name', this.state.associationName, '')
                      }
                      {/* {
                        this.state.associationNameRequired &&
                        <span className="form-text text-muted">Please enter your Association Name.</span>
                      } */}

                    </div>
					<div className="col-lg-4">
                      <label> Apartment Type *</label>
                      <select name="Apartment Type" id="uapartmentType" className="form-control" value={this.state.apartmenttype} onChange={this.handleFormFields}>
                        <option value="">Select Apartment Type</option>
                        {apartmentTypeData}
                      </select>
                      {
                        this.basicDetailValidator.message('Apartment Type', this.state.apartmentType, 'required')
                      }
                    </div>
                   
                    
                  </div>
                  <div className="form-group row">
				  <div className="col-lg-4">
                      <label>Apartment Mobile Number </label>
                      <input type="text" className="form-control" name="Apartment Phone No" id="uapartmentPhoneNumber" placeholder="Apartment Mobile Number" value={this.state.apartmentPhoneNumber} onChange={this.handleFormFields} />
                      {(this.state.apartmentPhoneNumberRequired != 0 ?
						  <div class="text-danger">Apartment Mobile Number Already exists.</div> :  this.apartmentDetailValidator.message('Apartment Phone No', this.state.apartmentPhoneNumber, 'phone|max:10') ) }
                    </div>
                    <div className="col-lg-4">
                      <label>Door Number *</label>

                      <input type="text" className="form-control" name="DoorNumber" id="udoorNumber" placeholder="Door Number" value={this.state.doorNumber} onChange={this.handleFormFields} />
                      {
                        this.basicDetailValidator.message('DoorNumber', this.state.doorNumber, 'required')
                      }
                      {
                        this.state.doorNumberRequired &&
                        <span className="form-text text-muted">Please enter your Door No.</span>
                      }
                    </div>


                    <div className="col-lg-4">
                      <label>Street Name *</label>
                      <input type="text" className="form-control" name="Street Name" id="ustreetName" placeholder="Street Name" value={this.state.streetName} onChange={this.handleFormFields} />
                      {
                        this.basicDetailValidator.message('Street Name', this.state.streetName, 'required')
                      }
                      {/* {
                        this.state.streetNameRequired &&
                        <span className="form-text text-muted">Please enter your Street Name.</span>
                      } */}
                    </div>



                   
					</div>



                  <div className="form-group row">
				   <div className="col-lg-4">
                      <label>Area *</label>

                      <input type="text" className="form-control" name="Area" id="uarea" placeholder="Area" value={this.state.area} onChange={this.handleFormFields} />
                      {
                        this.basicDetailValidator.message('Area', this.state.area, 'required')
                      }
                      {
                        this.state.areaRequired &&
                        <span className="form-text text-muted">Please enter your Area.</span>
                      }
                    </div>
                    <div className="col-lg-4">
                      <label>City *</label>
                      <select className="form-control" name="City" id="ucity" value={this.state.city} onChange={this.handleFormFields} >
                        <option value="">Select Your City</option>
                        {cityData}
                      </select>
                      {
                        this.basicDetailValidator.message('City', this.state.city, 'required|alpha_space')
                      }
                      {
                        this.state.cityRequired &&
                        <span className="form-text text-muted">Please enter your City .</span>
                      }
                    </div>

                    <div className="col-lg-4">
                      <label>Landmark *</label>
                      <input type="text" className="form-control" name="Landmark" id="ulandmark" placeholder="Landmark" value={this.state.landmark} onChange={this.handleFormFields} />
                      {
                        this.basicDetailValidator.message('Landmark', this.state.landmark, 'required|alpha_space')
                      }
                      {
                        this.state.landmarkRequired &&
                        <span className="form-text text-muted">Please enter your Landmark.</span>
                      }
                    </div>

                    </div>

                  <div className="form-group row">
				  <div className="col-lg-4">
                      <label>Pincode *</label>
                      <input type="text" className="form-control" name="pincode" id="upincode" placeholder="Pincode" value={this.state.pincode} onChange={this.handleFormFields} />
                      {
                        this.basicDetailValidator.message('pincode', this.state.pincode, 'required|integer|max:6|min:6')
                      }
                      {
                        this.state.pincodeRequired &&
                        <span className="form-text text-muted">Please enter your Pincode.</span>
                      }
                    </div>
					<div className="col-lg-4">
											<label>Profile Picture</label>
											<input type="file" className="form-control"  placeholder="Upload your file"  
											
											    onChange={(e)=> { this.handleChange(e)  }}  onClick={(e)=> { e.target.value = null}}
											
											 / >
										
						  </div>	
						  
						   <div className="col-lg-4">
											<label>Contract Document</label>
											<input type="file" className="form-control"  placeholder="Upload your file"  
											
											    onChange={(e)=> { this.documenturlChange(e)  }}  onClick={(e)=> { e.target.value = null}}
											
											 / >
									
						  </div>
                    
                    
                  </div>
                </div>
              </div>
            </div>

            {/* <!--end: Form Wizard Step 2--> */}

            {/* <!--begin: Form Wizard Step 3--> */}

            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content">
              <div className="kt-heading kt-heading--md">Apartment Details </div>
              <div className="kt-form__section kt-form__section--first">
                <div className="kt-wizard-v1__form">

                  <div className="form-group row">
                    <div className="col-lg-4">
                      <label>Road Size (in ft)</label>
                      <input name="Road Size" id="uroadSize" placeholder="Road Size in Ft" className="form-control" value={this.state.roadSize} onChange={this.handleFormFields} />
                      {
                        this.apartmentDetailValidator.message('Road Size', this.state.roadSize, 'integer,num')
                      }
                    </div>

                    <div className="col-lg-4">
                      <label>Distance between Gate & Sump (in ft)</label>
                      <input type="text" className="form-control" name="Distance between Gate and Sump" id="udistanceBetweenGateAndSump" placeholder="Distance between Gate & Sump" value={this.state.distanceBetweenGateAndSump} onChange={this.handleFormFields} />
                      {
                        this.apartmentDetailValidator.message('Distance between Gate & Sump', this.state.distanceBetweenGateAndSump, 'integer')
                      }
                      {
                        this.state.distanceBetweenGateAndSumpRequired &&
                        <span className="form-text text-muted">Please enter Distance between Gate & Sump.</span>
                      }
                    </div>
                    <div className="col-lg-4">
                      <label>Number of Towers</label>
                      <input type="text" className="form-control" name="No Of Towers" id="unumberOfTowers" placeholder="Number of Towers" value={this.state.numberOfTowers} onChange={this.handleFormFields} />
                      {
                        this.apartmentDetailValidator.message('No Of Towers', this.state.numberOfTowers, 'integer|max:1000,num')
                      }
                      {/* {
                        this.state.numberOfTowersRequired &&
                        <span className="form-text text-muted">Please enter Number of Towers.</span>
                      } */}
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-lg-4">
                      <label>Number of Homes</label>
                      <input type="text" className="form-control" name="No Of Homes" id="unumberOfHomes" placeholder="Number of Homes" value={this.state.numberOfHomes} onChange={this.handleFormFields} />
                      {
                        this.apartmentDetailValidator.message('No Of Homes', this.state.numberOfHomes, 'integer')
                      }
                      {/* {
                        this.state.numberOfHomesRequired &&
                        <span className="form-text text-muted">Please enter Number of Homes.</span>
                      } */}
                    </div>
                    <div className="col-lg-4">
                      <label>Sump/Tank Capacity (in kl) *</label>
                      <input type="text" className="form-control" name="Tank Capacity" id="utankCapacity" placeholder="Sump/Tank Capacity (in kl)" value={this.state.tankCapacity} onChange={this.handleFormFields} />
                      {
                        this.apartmentDetailValidator.message('Sump/Tank Capacity', this.state.tankCapacity, 'required|currency', { messages: { in: 'Sump/Tank Capacity should be a valid number!' } })
                      }
                      {
                        this.state.tankCapacityRequired &&
                        <span className="form-text text-muted">Please enter Sump/Tank Capacity.</span>
                      }
                    </div>


                    <div className="col-lg-4">
                      <label>Daily Need (in kl) *</label>
                      <input type="text" className="form-control" name="Daily Need" id="udailyNeed" placeholder="Daily Need (in kl)" value={this.state.dailyNeed} onChange={this.handleFormFields} />
                      {
                        this.apartmentDetailValidator.message('Daily Need', this.state.dailyNeed, 'required|currency')
                      }
                      {
                        this.state.dailyNeedRequired &&
                        <span className="form-text text-muted">Please enter Daily Need.</span>
                      }
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-lg-4">
                      <label>Preferred TDS *</label>
                      <select name="Total Dissolved Solids" className="form-control" id="utotalDissolvedSolids" value={this.state.totalDissolvedSolids} onChange={this.handleFormFields} >
                        <option value="">Select TDS</option>
                        <option value="less than 300(Excellent)"> less than 300(Excellent) </option>
                        <option value="300-500(Good)"> 300-500(Good) </option>
                        <option value="600-900(Fair)"> 600-900(Fair) </option>
                        <option value="900-1200(Poor)"> 900-1200(Poor)</option>
                        <option value="Above 1200(Unacceptable)"> Above 1200(Unacceptable)   </option>
                      </select>
                      {
                        this.apartmentDetailValidator.message('Preferred tds', this.state.totalDissolvedSolids, 'required|string')
                      }
                    </div>

					{ /* <div className="col-lg-4">
                      <label>Contract Document</label>
                      <input type="file" className="form-control" id="ucontractDocument" placeholder="Upload your file" ></input>
                    </div>  */ }
                  </div>
                </div>
              </div>
            </div>


            {/* <!--end: Form Wizard Step 2--> */}

            {/* <!--begin: Form Wizard Step 3--> */}

            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content">
              <div className="kt-heading kt-heading--md">Contact Details </div>
              <div className="kt-form__section kt-form__section--first">
                <div className="kt-wizard-v1__form">
                  <div className="form-group row">
                    <div className="col-lg-4">

                      <label>Contact Person 1 *</label>
                      <input type="text" className="form-control" name="Name1" id="upocName1" placeholder="Name" value={this.state.pocName1} onChange={this.handleFormFields} />
                      {
                        this.pocValidator.message('Contact Person 1', this.state.pocName1, 'required|alpha_space')
                      }
                      {
                        this.state.pocName1Required &&
                        <span className="form-text text-muted"></span>
                      }
                    </div>
                    <div className="col-lg-4">
                      <label>Contact Number *</label>
                      <input type="text" className="form-control" name="pocContactNumber1" id="upocContactNumber1" placeholder="Contact Number" value={this.state.pocContactNumber1} onChange={this.handleFormFields} />
					   {(this.state.apartmentcontact1Required != 0 ?
						  <div class="text-danger">Contact Number 1  Already exists.</div> : this.pocValidator.message('Contact Number 1', this.state.pocContactNumber1, 'required|phone|max:10') ) }
                     

                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-lg-4">
                      <label>Contact Person 2</label>
                      <input type="text" className="form-control" name="Name2" id="upocName2" placeholder="Name" value={this.state.pocName2} onChange={this.handleFormFields} />
						  {/* <!--   {
                        this.pocValidator.message('Name2', this.state.pocName2, 'alpha_space')
                      }
                      {
                        this.state.pocName2Required &&
                        <span className="form-text text-muted"></span>
                      }  --> */}
                    </div> 
                    <div className="col-lg-4">
                      <label>Contact Number</label>
                      <input type="text" className="form-control" name="pocContactNumber2" id="upocContactNumber2" placeholder=" Contact Number" value={this.state.pocContactNumber2} onChange={this.handleFormFields} />
					   {(this.state.apartmentcontact2Required != 0 ?
						  <div class="text-danger">Contact Number 2  Already exists.</div> : this.pocValidator.message('Contact Number 2', this.state.pocContactNumber1, 'phone|max:10') ) } 
                     {/* <!--   {
                        this.pocValidator.message('pocContactNumber2', this.state.pocContactNumber2, 'required|phone|max:14')
                      }
                      {
                        this.state.pocContactNumber2Required &&
                        <span className="form-text text-muted">Please enter your Contact Number.</span>
                      }  --> */}

                    </div>

                  </div>

                </div>
              </div>
            </div>


            {/* <!--end: Form Wizard Step 3--> */}



            {/* <!--begin: Form Wizard Step 4--> */}
            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content">
              <div className="kt-heading kt-heading--md">Review your Details and Submit</div>
              <div className="kt-form__section kt-form__section--first">
                <div className="kt-wizard-v1__review">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="kt-wizard-v1__review-item">
                        <div className="kt-wizard-v1__review-title">
                          Basic Details
                                                                </div>
                        <div className="kt-wizard-v1__review-content">
                          Apartment Name : {this.state.apartmentName} <br />
                          Association Name : {this.state.associationName} <br />
						  Apartment Mobile Number : {this.state.apartmentPhoneNumber} <br />
                          Door Number : {this.state.doorNumber} <br />
                          Street Name : {this.state.streetName} <br />
                          Area : {this.state.area} <br />
                          City : {this.state.city} <br />
                          Landmark : {this.state.landmark} <br />
                          Pincode : {this.state.pincode} <br />
                          Apartment Type:{this.state.apartmentType}<br />
                          
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="kt-wizard-v1__review-item">
                        <div className="kt-wizard-v1__review-title">
                          Apartment Details
                                                                </div>
                        <div className="kt-wizard-v1__review-content">
                          Road Size:{this.state.roadSize}<br />
                          Distance Between Gate & Sump: {this.state.distanceBetweenGateAndSump} <br />
                          Number of Towers : {this.state.numberOfTowers} <br />
                          Number of Homes : {this.state.numberOfHomes} <br />
                          Sump/Tank Capacity : {this.state.tankCapacity} <br />
                          Daily Need : {this.state.dailyNeed} <br />
                          Preferred TDS: {this.state.totalDissolvedSolids} <br />
                        </div>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="kt-wizard-v1__review-item">
                        <div className="kt-wizard-v1__review-title">
                          Contact Details
                                                                </div>
                        <div className="kt-wizard-v1__review-content">
                          Name : {this.state.pocName1} <br />
                          Contact Number : {this.state.pocContactNumber1} <br />
                          Name : {this.state.pocName2} <br />
                          Contact Number : {this.state.pocContactNumber2} <br />

                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>

            {/* <!--end: Form Wizard Step 4--> */}

            {/* <!--begin: Form Actions --> */}
            <div className="kt-form__actions">
              <button className="btn btn-secondary btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u" data-ktwizard-type="action-prev" onClick={this.prevStep}>
                Previous
                                                    </button>
              <Button
                className="btn btn-success btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u"
                data-ktwizard-type="action-submit"
                onClick={this.submit} disabled={this.state.disableSubmit}
              >
                {this.state.disableSubmit ? 'Submitting' : 'Submit'}
              </Button>
              <button className="btn btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u" data-ktwizard-type="action-next" onClick={this.nextStep}>
                Next Step
                                                    </button>
            </div>

            {/* <!--end: Form Actions --> */}
          </form>

          {/* <!--end: Form Wizard Form--> */}
        </div>
      </div>
    </>
    );
  }
}
const mapStateToProps = (state /*, ownProps*/) => {
  return {
	userfName:state.auth.user[0].userFirstName,
	userlName:state.auth.user[0].userLastName,
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id,
	userInfostatus:  state.auth.user[0].userInfostatus,
  }
}

export default connect(
  mapStateToProps,
  null
)(CreateApartmentuserInfoagg)
